



























































import { Component, Mixins } from "vue-property-decorator";
import { mapGetters } from "vuex";
import HashVerificationMixin from "@/mixins/hashVerificationMixin";

@Component({
  components: {
    "set-password-form": () =>
      import("@/components/app/global/auth/setPasswordForm.vue")
  },
  computed: {
    ...mapGetters({
      currentOauthClient: "auth/client/currentOauthClient",
      defaultOauthClient: "auth/client/defaultOauthClient",
      isSupportedOauthClient: "auth/client/isSupportedOauthClient",
      defaultOauthClientRedirect: "auth/client/defaultOauthClientRedirect"
    })
  }
})
export default class Verify extends Mixins(HashVerificationMixin) {
  // Data
  public hasError = false;
  public isSupportedOauthClient!: boolean;

  // Life-cycle methods
  public async created() {
    if (!this.isSupportedOauthClient) return;
    await this.initHashVerification();
    this.completeVerification();
  }

  // Computed
  public get title() {
    return this.hash.passwordRequired
      ? "_.set_account_password"
      : "_.verifying_email_address";
  }

  public get hasErrored() {
    return this.hash.isExpiredOrInvalid || this.hasError;
  }

  // Methods
  private async completeVerification() {
    if (this.hash.isExpiredOrInvalid) return;
    if (this.hash.passwordRequired) return;
    try {
      // Complete registration
      await this.$store.dispatch("auth/client/completeRegistration", {
        reg_hash: this.reg_hash,
        username: this.username
      });
      // Open toast
      this.$buefy.toast.open({
        message: this.$t(
          "_sentence.account_activation_was_successful"
        ) as string
      });
    } catch (error) {
      this.hasError = true;
      this.$store.dispatch("api/handleError", error);
    }
  }
}
